import React, { useState, useEffect } from "react";
import { Dropdown, Menu, Badge } from "antd";
import { MoreOutlined, CloseOutlined } from "@ant-design/icons";
import './Styles.css';

// Componente para el menú hamburguesa de botones
const ButtonsDropdown = ({ buttons, badgeDot = false }) => {
  const [visible, setVisible] = useState(false);

  const menu = (
    <Menu className="header-buttons-dropdown-menu">
      <div className="header-buttons-close-btn" onClick={() => setVisible(false)}>
        <CloseOutlined />
      </div>
      {buttons.map((btn, idx) => (
        <Menu.Item key={idx}>
          {btn}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      placement="bottomRight"
      visible={visible}
      onVisibleChange={setVisible}
    >
      <Badge dot={badgeDot} offset={[-4, 4]} style={{ backgroundColor: '#ff4d4f' }}>
        <div className="header-buttons-menu-trigger">
          <MoreOutlined />
        </div>
      </Badge>
    </Dropdown>
  );
};

const HeaderActions = ({
  children,
  maxButtonsBeforeCollapse = 1,
  badgeDot = false,
}) => {
  const [processedContent, setProcessedContent] = useState(null);

  useEffect(() => {
    // Procesar children para separar segmented, divider y botones
    const childrenArray = React.Children.toArray(children);

    let segmented = null;
    let divider = null;
    const buttons = [];

    childrenArray.forEach((child) => {
      if (!child) return;

      // Detectar SegmentedItem (por className o tipo)
      if (React.isValidElement(child)) {
        const className = child.props?.className || '';

        // Si es SegmentedItem
        if (className.includes('segmented-custom') || child.type?.name === 'SegmentedItem') {
          segmented = child;
        }
        // Si es el divider
        else if (className.includes('header-divider')) {
          divider = child;
        }

        else if (child.type === React.Fragment) {
          const fragmentChildren = React.Children.toArray(child.props.children);
          fragmentChildren.forEach(fragmentChild => {
            if (React.isValidElement(fragmentChild)) {
              const fragClassName = fragmentChild.props?.className || '';
              if (fragClassName.includes('segmented-custom') || fragmentChild.type?.name === 'SegmentedItem') {
                segmented = fragmentChild;
              } else if (fragClassName.includes('header-divider')) {
                divider = fragmentChild;
              } else {
                buttons.push(fragmentChild);
              }
            }
          });
        }
        // Es un botón u otro elemento
        else {
          buttons.push(child);
        }
      }
    });

    // Filtrar botones válidos (eliminar null, undefined, false)
    const validButtons = buttons.filter(Boolean);

    // Determinar si hay que colapsar botones
    const shouldCollapseButtons = validButtons.length >= maxButtonsBeforeCollapse;

    // Generar contenido procesado
    const content = (
      <>
        {segmented && (
          <>
            {segmented}
            {divider || <div className="header-divider"></div>}
          </>
        )}

        {shouldCollapseButtons ? (
          <ButtonsDropdown buttons={validButtons} badgeDot={badgeDot} />
        ) : (
          validButtons
        )}
      </>
    );

    setProcessedContent(content);
  }, [children, maxButtonsBeforeCollapse, badgeDot]);

  return (
    <div className="header-actions">
      {processedContent}
    </div>
  );
};

export default HeaderActions;
